import { useState } from "react";
import * as React from "react";
import firebase, { firestore } from "firebase/app";
import { useFirestore, useFirestoreCollection } from "reactfire";
import { List } from "immutable";
import { ShowItem } from "./ShowItem";
import { ListItem } from "./ListItem";
import { Palette } from "./Palette";
import { Toolbox } from "./Toolbox";

import library from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faTrash,
  faCheckSquare,
  faFolderPlus,
  faPalette,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors, itemColors } from "../App";

export enum Mode {
  Normal,
  Delete,
  Fill,
}

export const ToDoList = (props: { listID: string }) => {
  const [fieldValue, setFieldValue] = useState("");
  const [mode, setMode] = useState(Mode.Normal);
  const [showInput, setShowInput] = useState(true);
  const [selectedColor, setSelectedColor] = useState(0);
  document.documentElement.style.setProperty(
    "--selectedColor",
    itemColors[selectedColor]
  );
  const firestore = useFirestore();
  const itemsRef = useFirestore()
    .collection("lists")
    .doc(props.listID)
    .collection("items");

  const data: firestore.QuerySnapshot<ListItem> = (useFirestoreCollection(
    itemsRef
  ) as unknown) as firestore.QuerySnapshot<ListItem>;

  const pressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      const newItem: ListItem = {
        name: fieldValue,
        checked: false,
        progress: 0,
        created: firebase.firestore.Timestamp.now(),
        colorIndex: selectedColor,
      };
      firestore
        .collection("lists")
        .doc(props.listID)
        .collection("items")
        .add(newItem);
      setFieldValue("");
    }
  };

  return (
    <div
      className="items"
      onClick={() => {
        window.scrollTo(0, 0);
        //setShowInput(!showInput);
      }}
    >
      {showInput && (
        <div>
          <Toolbox setMode={setMode} mode={mode} />
          <div className="top">
            <input
              className="input itemField"
              onClick={(e) => e.stopPropagation()}
              placeholder="Type here"
              autoFocus
              type="text"
              value={fieldValue}
              onChange={(event) => setFieldValue(event.target.value)}
              onKeyDown={pressEnter}
            />
          </div>
        </div>
      )}
      {mode == Mode.Fill && (
        <Palette
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
        />
      )}
      {List(data.docs)
        .sortBy((doc) => -(doc.data().created?.toMillis() ?? 0))
        .map((doc) => (
          <ShowItem
            mode={mode}
            onClick={() => setShowInput(true)}
            key={doc.id}
            item={doc.data()}
            docRef={doc.ref}
            selectedColor={selectedColor}
          />
        ))}
    </div>
  );
};
